// "Not finding the right person?" row on Talent Network. Positions come from Platform_Config
// TALENT_NETWORK_HIRE_NUDGE_AFTER (a JSON array, e.g. [5,20]) via GET /platformConfig.
export const DEFAULT_NUDGE_POSITIONS = [5, 20];
// Prototype NUDGE_MIN_RESULTS: too few results to be worth the interruption.
const MIN_RESULTS = 4;

export function parseNudgePositions(raw: unknown): number[] {
  let value = raw;
  if (typeof raw === "string") {
    try {
      value = JSON.parse(raw);
    } catch {
      value = null;
    }
  }
  const positions = Array.isArray(value) ? value.filter((n): n is number => Number.isInteger(n) && n > 0) : [];
  return positions.length ? [...new Set(positions)].sort((a, b) => a - b) : DEFAULT_NUDGE_POSITIONS;
}

/** Indexes (0-based, within the current page) after which the row is inserted. */
export function hireNudgeAfter({
  positions,
  page,
  limit,
  shown,
  total,
}: {
  positions: number[];
  page: number;
  limit: number;
  shown: number;
  total: number;
}): Set<number> {
  const out = new Set<number>();
  if (total < MIN_RESULTS) return out;
  const offset = (page - 1) * limit;
  for (let i = 0; i < shown; i += 1) {
    const position = offset + i + 1;
    // A list shorter than the first position still gets one, at its end.
    if (positions.includes(position) || (total < positions[0] && position === total)) out.add(i);
  }
  return out;
}
